<!-- bottom-sheet.component.html -->
<section>
    <div class="w-100 d-flex" style="gap: .5rem;">
        <img src="../../../../assets/icons/72X72nfmgenie.png" alt="icon" style="width: 50px;height: 50px;">
        <h5 class="font-weight-bold">Install MyFoodGenie Lite on your HomeScreen</h5>
    </div>
    <hr>
    <p>This site has app functionality. Add it to your Home Screen for extensive experience and easy access</p>
    <hr>
    <ol>
        <li><i class="fa fa-compass"></i><span>1. Open in Safari or Chrome Browser</span></li>
        <li><i class="fa fa-share-square-o"></i><span>2. Press Share in Navigation Bar</span></li>
        <li><i class="fa fa-plus-square-o"></i><span>3. Press Add to Home Screen</span></li>
    </ol>
</section>